import React from 'react';
import {Form, Button} from 'react-bootstrap';
import { BiCabinet } from 'react-icons/bi';
import { FaArrowLeft,FaTimes } from 'react-icons/fa';
import PropTypes from 'prop-types';
export const DataForm = ({state, setState, onRestart, _items_spliter})=>{
	
	const onReservedCheck = (e) => {
		let itemName = e.target.getAttribute('name');
		setState((prevState) => {
			let reserved = prevState.data.reserved;
			if (reserved !== "" && reserved.indexOf(itemName) === -1)
				reserved += (";" + itemName);
			else if (reserved.indexOf(itemName) !== -1)
				reserved = reserved.replace(_items_spliter+itemName,"").replace(itemName,"");		
			else if (reserved === "")
				reserved = itemName;
			return { ...prevState, ...{data:{...prevState.data, ...{ reserved: reserved }} } }	
		})
	}
	const onLocationChange = (e) => {
		let location = e.target.value;
		setState((prevState) => {
			return { ...prevState, ...{data:{...prevState.data, ...{ location: location }} } }	
		})
	}
	const onReservedOthersChange = (e) => {
		let reserved_others = e.target.value;
		setState((prevState) => {
			return { ...prevState, ...{data:{...prevState.data, ...{ reserved_others: reserved_others }} } }	
		})
	}
	const onDisposedOthersChange = (e) => {
		let disposed_others = e.target.value;
		setState((prevState) => {
			return { ...prevState, ...{data:{...prevState.data, ...{ disposed_others: disposed_others }} } }	
		})
	}
	const onDisposedCheck = (e) => {
		let itemName = e.target.getAttribute('name');
		setState((prevState) => {
			let disposed = prevState.data.disposed;
			if (disposed !== "" && disposed.indexOf(itemName) === -1)
				disposed += (";" + itemName);
			else if (disposed.indexOf(itemName) !== -1)
				disposed = disposed.replace(_items_spliter+itemName,"").replace(itemName,"");	
			else if (disposed === "")
				disposed = itemName;
			return { ...prevState, ...{data:{...prevState.data, ...{ disposed: disposed }} } }	
		})
	}

	const handleBackToPreviousStage = React.useCallback(
		(stage, clearProp) => {
			let update = { stage: stage };
			setState(prevState => {
				[clearProp].forEach((prop) => {
					if (prevState[prop]) {
						URL.revokeObjectURL(prevState[prop]);
					}
					update[clearProp] = '';
				})
				return { ...prevState, ...update };
			})
		},
		[setState]
	);

	let locationError = false;
	if((state.data.reserved.length !== 0 || state.data.reserved_others.length !== 0) && state.data.location.length === 0) 
		locationError = true;
	
	return(
		<>
			<h4 className="display-5 text-center">Please fill below data form for clear record of <BiCabinet /> {state.scanText}</h4>
			<br />
			<h4>Cut padlock?</h4>
			<br />
			<Form.Check
				type={'radio'}
				id={`cut-padlock-yes-radio`}
				checked={state.data.cutPadlock === "Yes"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{data:{...prevState.data, ...{ cutPadlock: "Yes" }} } }
					})
				}}
				label={`Yes`}
			/>
			<br />
			<Form.Check
				type={'radio'}
				id={`cut-padlock-no-radio`}
				checked={state.data.cutPadlock === "No"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{data:{...prevState.data, ...{ cutPadlock: "No" }} } }
					})
				}}
				label={`No`}
			/>
			<br />
			<h4>Items found?</h4>
			<br />
			<Form.Check
				type={'radio'}
				id={`items-found-yes-radio`}
				checked={state.data.itemsFound === "Yes"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{data:{...prevState.data, ...{ itemsFound: "Yes" }} } }
					})
				}}
				label={`Yes`}
			/>
			<br />
			<Form.Check
				type={'radio'}
				id={`items-found-no-check-box`}
				checked={state.data.itemsFound === "No"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{data:{...prevState.data, ...{ itemsFound: "No" }} } }
					})
				}}
				label={`No`}
			/>
			<br />
			<h4>Reserved</h4>
			{["Bag(s)",
				"Library book(s)",
				"Camera(s)",
				"Certificate(s)",
				"Clothes",
				"Digital product(s)",
				"Personal valuable belonging(s)",
				"Shoe(s)",
				"Sport good(s)",
				"Stationary(ies)",
				"Tool(s)",
				"Toy(s)",
				"X-ray"
			].map((item) => {
				return (
					<>
						<br />
						<Form.Check
							type={'checkbox'}
							id={'reserved-' + item + '-checkbox'}
							checked={(state.data.reserved && state.data.reserved.indexOf(item) !== -1)}
							name={item}
							onChange={onReservedCheck}
							label={item}
						/>
					</>
				);
			})}
			<br/>
			<h4>Reserved Others</h4>
			<br />
			<Form.Control type="input" placeholder="" onChange={onReservedOthersChange} value={state.data.reserved_other}/>
			<br/>
			<h4>Location</h4>
			<br />
			<Form.Control type="input" placeholder="" onChange={onLocationChange} value={state.data.location}/>
			{locationError &&
				<>
				<br />
				<small style={{color:'red'}}><b>Please fill in the location</b></small>
				<br />
				</>
			}
			<br />
			<h4>Disposed</h4>
			{["Book(s)",
				"Cloth ",
				"Clothes",
				"Food",
				"Graduation gown",
				"Lab material(s)",
				"Laboratory gowns",
				"Library item(s)",
				"Miscellaneous",
				"Notes",
				"Paper",
				"Personal belongings",
				"Shoe(s)",
				"Sport good(s)",
				"Stationary(ies)",
				"Tool(s)"
			].map((item) => {
				return (
					<>
						<br />
						<Form.Check
							type={'checkbox'}
							id={'disposed-' + item + '-checkbox'}
							checked={(state.data.disposed && state.data.disposed.indexOf(item) !== -1)}
							name={item}
							onChange={onDisposedCheck}
							label={item}
						/>
					</>
				);
			})}
			<br />
			<h4>Disposed Others</h4>
			<br />
			<Form.Control type="input" placeholder="" onChange={onDisposedOthersChange} value={state.data.disposed_other}/>
			<br />
			<Button block variant="outline-secondary" className="text-center"
				onClick={() => { handleBackToPreviousStage('CAPTURE_IMAGE_AND_VIDEO', ['lockerItemsCleared']) }}>
				<FaArrowLeft />Back
			</Button>
			<Button block variant="outline-secondary" className="text-center"
				onClick={onRestart}>
				<FaTimes />Cancel
			</Button>
			<Button 
				disabled={locationError ? "disabled" : ""}
				className={(locationError
				? "btn-secondary text-center"
				: "btn-success text-center")}
				block 
				onClick={() => {
					setState(prevState => {
						return { ...prevState, ...{ stage: "DATA_CONFIRM" } };
					})
				}}>
				Confirm
			</Button>
		</>
	)
}
DataForm.propTypes = {
	state: PropTypes.object,
	setState: PropTypes.func,
	onRestart: PropTypes.func,
	_items_spliter: PropTypes.string
};
